(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/models/PriceList',["backbone"], function(Backbone) {
    var isPrint, layout;
    isPrint = $("#container").data("mediagroup") === "print";
    layout = isPrint ? "SPVficr" : "SVficr";
    return (function(superClass) {
      extend(_Class, superClass);

      function _Class() {
        return _Class.__super__.constructor.apply(this, arguments);
      }

      _Class.prototype.urlRoot = function() {
        if (isPrint) {
          return "/Advertising/Print/Prices/";
        } else {
          return "/Advertising/Digital/Prices/";
        }
      };

      _Class.prototype.defaults = {
        layout: layout,
        selectedPriceId: ""
      };

      _Class.prototype.layout = function(code) {
        var array;
        array = [];
        code = code.replace(/[^spfvcir]+/gi, "");
        _.each(code, function(char) {
          if (!_.contains(array, char.toUpperCase() || !_.contains(array, char.toLowerCase()))) {
            return array.push(char);
          }
        });
        return this.set({
          layout: array.join("")
        });
      };

      _Class.prototype.isPrint = isPrint;

      return _Class;

    })(Backbone.Model);
  });

}).call(this);

//# sourceMappingURL=PriceList.js.map
;
